import { formatOrder, PayinBank } from '~/entities/payin';

export const bankOptions = Object.values(PayinBank)
    .filter((bank) => {
        return bank !== PayinBank.BANK_UNSPECIFIED;
    })
    .map((bank) => {
        return {
            value: bank,
            label: formatOrder.bank(bank),
        };
    });
